import type { AllRouteEndpoints } from "../routeTypes";

export const pushTokenStatusCacheKey = "/apps/user_info/:user_identifier/push_token_status" as const;
export const userInfoCacheKey = "/apps/user_info/:user_identifier" as const;
export const userInfosCacheKey = "/apps/user_infos/:user_identifier" as const;
export const userInfoAnyUsersCacheKey = "/apps/user_info_any_users" as const;
export const userInfoCampaignsCacheKey = "/apps/user_info_campaigns/:user_identifier" as const;
export const userInfoSegmentsCacheKey = "/apps/user_info_segments/:user_identifier" as const;
export const userInfoLinkedBusinessAccountsCacheKey =
  "/apps/user_info_linked_business_accounts/:user_identifier" as const;
export const customObjectsNotLinkedToUserCacheKey =
  "/custom_objects/:type_name/not_linked_to_user/:user_identifier" as const;

export const userInfoLinkBusinessAccountsCacheKeys: AllRouteEndpoints[] = [
  userInfoLinkedBusinessAccountsCacheKey,
  customObjectsNotLinkedToUserCacheKey,
];

export const SubscriptionStatuses = {
  UNSUBSCRIBED: 0,
  SUBSCRIBED: 1,
  OPTED_IN: 2,
} as const;
